import { AbstractSubscriber, IFacet, IMultipleResults } from '.'
import { ISearchConfig } from './ISearchConfig'
import { cloneObject } from '../utils'

export abstract class AbstractSearchCore {
  subscribers: AbstractSubscriber[] = []
  groupId: string
  initialConfig: any
  config: any
  configs: any
  constructor(groupId: string, config?: any) {
    this.initialConfig = cloneObject(config || {})

    this.config = config
    this.groupId = groupId
  }
  public getGroupId(): string {
    return this.groupId
  }

  public async subscribe(subscriber: AbstractSubscriber): Promise<void> {
    if (this.subscribers.indexOf(subscriber) == -1) {
      this.subscribers.push(subscriber)
      subscriber.attached(this)
    }
  }

  public unsubscribe(subscriber: AbstractSubscriber): void {
    const index = this.subscribers.indexOf(subscriber)
    if (index !== -1) {
      subscriber.detaching()
      this.subscribers.splice(index, 1)
    }
  }

  public getSubscribers(): AbstractSubscriber[] {
    return this.subscribers
  }
  public countSubscribers(): number {
    return this.subscribers.length
  }

  public destroy(): void {
    this.subscribers.map((value: AbstractSubscriber) => {
      value.detaching()
    })
    this.subscribers = []
  }

  abstract get searchConfig(): ISearchConfig
  abstract applySearchConfig(searchConfig: ISearchConfig, notify?: boolean): Promise<void>
  abstract executeSearch(
    searchConfig: ISearchConfig,
    disableNotification?: boolean
  ): Promise<IMultipleResults>
  abstract setFacet(facet: IFacet): Promise<IMultipleResults>
  abstract clearFacet(facetName: string): void
  abstract applyMultipleFacets(facets: IFacet[]): void
  abstract applyDateFilters(
    dateFilters: number[],
    redirect?: boolean,
    analyticsValue?: string
  ): void
  abstract getFacets(): IFacet[]
  abstract setPage(
    pageNumber: number,
    indexName?: string,
    notify?: boolean
  ): Promise<IMultipleResults>
  abstract clearAll(redirectToSearch?: boolean): Promise<void>
  abstract goToSearch(redirectToSearch?: boolean, resetPagination?: boolean): Promise<void>
  abstract getObjects(index: string, ids: string[]): Promise<any[]>
  abstract getIndexesWithGeo(): string[]
  abstract resetAllConfigs(): Promise<void>

  public serialize(): any {
    return {
      groupId: this.groupId,
      config: this.config,
    }
  }

  public deserialize(data: any): AbstractSearchCore {
    if (data.groupId) this.groupId = data.groupId
    if (data.config) this.config = data.config

    return this
  }
}
